import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto;
  width: 100%;
  padding-top: 30px;
`;
